import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "financialFitness"
};
const _hoisted_2 = {
    key: 0,
    class: "score"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'FinancialFitnessScore',
    props: {
        started: {},
        dayToDay: {},
        security: {},
        future: {},
        score: {},
        mini: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            return (_openBlock(), _createElementBlock("div", null, [
                (!_ctx.mini)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                width: "5",
                                "model-value": _ctx.started,
                                size: 160,
                                color: "#9EA2D0",
                                "bg-color": "#9EA2D011"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_progress_circular, {
                                        width: "5",
                                        "model-value": _ctx.dayToDay,
                                        size: 130,
                                        color: "#C7989E",
                                        "bg-color": "#C7989E11"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_progress_circular, {
                                                width: "5",
                                                "model-value": _ctx.security,
                                                size: 100,
                                                color: "#77A4A7",
                                                "bg-color": "#77A4A711"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_progress_circular, {
                                                        width: "5",
                                                        "model-value": _ctx.future,
                                                        size: 70,
                                                        color: "#5f5672",
                                                        "bg-color": "#5f56727511"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (_ctx.score != undefined && _ctx.score != null)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.score), 1))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["model-value"])
                                                ]),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ]),
                                        _: 1
                                    }, 8, ["model-value"])
                                ]),
                                _: 1
                            }, 8, ["model-value"]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.mini)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 1,
                        width: "4",
                        "model-value": _ctx.score,
                        size: 85,
                        color: "#E3C9C2",
                        "bg-color": "#f7faf7"
                    }, {
                        default: _withCtx(() => [
                            (_ctx.score != undefined && _ctx.score != null)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass('score ' + (_ctx.mini ? 'mini' : ''))
                                }, _toDisplayString(_ctx.score), 3))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["model-value"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
